import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Board from 'react-trello';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { encryptId, formatPrice } from '../../../../../_metronic/helpers';
import { colorStatusCuentasCobrar } from '../../../../../_metronic/helpers/CustomElements';
import { UserImage } from '../../../../../_metronic/helpers/components/UserImage';
import { actualizarEtapaPedidos } from '../../../../service/pedidos/Pedidos';

type Props = {
  etapasConCuentas: any;
  onRefreshData: () => void;
};

const ListadoTarjeta: React.FC<Props> = ({
  etapasConCuentas = [],
  onRefreshData,
}) => {
  const history = useHistory();
  const [actualizaTablero, setActualizaTablero] = useState<number>(
    Math.random() * 40
  );
  const databoard = {
    lanes: etapasConCuentas,
  };
  const tarjeta = (props: any) => {
    const {
      id,
      nombre,
      folio,
      createdAt,
      vendedorAsignado,
      compradorAsignado,
      monto_c_imp,
      unidadMoneda,
      draggable,
      status,
    } = props;

    let nombre_estatus = '';
    let codigo_estatus = '';
    if (status) {
      nombre_estatus = status.name;
      codigo_estatus = status.code;
    }

    return (
      <div
        className="card mb-2 borders-card-board cursor-pointer"
        // onClick={() => {
        //   history.push(`/cobranza/cuentas_cobrar/${encryptId(id.toString())}`);
        // }}
        title={nombre}
        style={{ cursor: !draggable ? 'not-allowed' : '' }}
      >
        <div className="card-header d-flex border-0 mt-3 padding-card-board ">
          <div className="wh-0100">
            <div className="sp-bt-c wh-0100">
              <span className="fw-bolder text-gray-700 large-text">
                {nombre}
              </span>
              <UserImage user={vendedorAsignado}></UserImage>
            </div>
          </div>
          <div className="wh-0100 mt-2">
            <div className="sp-bt-c wh-0100">
              <span className="text-gray-700 large-text">
                {new Date(createdAt).toISOString().split('T')[0]}
              </span>
              <UserImage user={compradorAsignado}></UserImage>
            </div>
          </div>
        </div>
        <div className="card-body padding-card-board mt-2">
          <div className="sp-bt-c mb-5">
            <div className="text-gray-600 mt-1 fw-semibold fs-7 mb-2">
              <span className="text-gray-700 fw-bolder">
                {`${formatPrice(monto_c_imp, 'es-MX', 'MXN', 2, 2)}`}
              </span>
              <span className="text-gray-600 ms-3 fs-8">
                {unidadMoneda
                  ? `/ ${unidadMoneda.code}`
                  : 'Sin unidad de moneda'}
              </span>
            </div>
          </div>
        </div>
        <div className="card-body padding-card-board">
          <div className="sp-bt-c mb-5">
            <div className="text-gray-600 fw-semibold fs-7 mb-2">
              <span className="text-gray-700 fw-bolder">{folio}</span>
            </div>
            <div className="margin-left-020">
              <span className={`${colorStatusCuentasCobrar(codigo_estatus)}`}>
                {nombre_estatus}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const encabezado = (props: any) => {
    const {
      color_etapa,
      title,
      monto_total_usd,
      monto_total_mxn,
      code,
      etapa_id,
    } = props;
    return (
      <>
        <div
          className="card borders"
          style={{ borderTop: `solid 5px ${color_etapa}` }}
        >
          <div
            className="sp-bt-c padding-card-board"
            style={{ minHeight: '60px' }}
          >
            <div className="d-flex w-70">
              <div className="large-text fw-bolder text-gray-700">{title}</div>
            </div>
            <div
              className="text-muted cursor-pointer "
              title="Total de cuentas"
            >
              {props.cards.length}
            </div>
          </div>
          <div className="d-flex gap-2 flex-wrap w-100 mb-4">
            <span
              className="badge badge-light-success fs-7 fw-bold ms-8"
              title="Total en MXN"
            >
              {`${formatPrice(monto_total_mxn, 'es-MX', 'MXN', 2, 2)}`} MXN
            </span>
            <span
              className="badge badge-light-info fs-7 fw-bold"
              title="Total en USD"
            >
              {`${formatPrice(monto_total_usd, 'es-MX', 'MXN', 2, 2)}`} USD
            </span>
          </div>
        </div>
      </>
    );
  };

  const actualizaOrden = async (id: number, codeStage: string) => {
    const values = {
      id: id,
      etapaCode: codeStage,
    };
    actualizarEtapaPedidos(values)
      .then((res) => {
        const {
          data: { message },
        } = res;
        onRefreshData();
        toast.success(message, {
          position: 'top-right',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      })
      .catch((err) => {
        onRefreshData();
        toast.error(
          'Hubo un problema al intentar cambiar de etapa, intentelo más tarde',
          {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          }
        );
      });
  };
  const components = {
    Card: tarjeta,
    LaneHeader: encabezado,
  };

  return (
    <>
      {
        <Board
          key={actualizaTablero}
          data={databoard}
          onCardClick={(event: any) => {}}
          handleDragEnd={async (
            cardId: any,
            sourceLaneId: any,
            targetLaneId: any,
            position: any,
            cardDetails: any
          ) => {
            if (targetLaneId !== sourceLaneId) {
              switch (targetLaneId) {
                case 'PED_PAID':
                  Swal.fire({
                    title: '¿Confirmas que deseas cambiar el pedido a pagado?',
                    html: `
                    <div className="text-gray-600">
                      El pedido se marcará como pagado. Una vez pagado, no podrás modificar ningún dato asociado a el.
                    </div>
                    `,
                    showCancelButton: true,
                    padding: '2em',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar',
                    reverseButtons: true,
                    customClass: {
                      confirmButton: 'btn btn-primary',
                      cancelButton: 'btn btn-light me-3',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      actualizaOrden(cardId, targetLaneId);
                    } else {
                      setActualizaTablero(Math.random() * 40);
                    }
                  });
                  break;
                default:
                  actualizaOrden(cardId, targetLaneId);
                  break;
              }
            }
          }}
          editable
          components={components}
        />
      }
    </>
  );
};

export { ListadoTarjeta };
